import { render, staticRenderFns } from "./RolePermissions.vue?vue&type=template&id=869eeca0&scoped=true&"
import script from "./RolePermissions.vue?vue&type=script&lang=ts&"
export * from "./RolePermissions.vue?vue&type=script&lang=ts&"
import style0 from "./RolePermissions.vue?vue&type=style&index=0&id=869eeca0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869eeca0",
  null
  
)

export default component.exports